<template>
  <div class="wrapGridArea">
    <div class="title">2개의 Grid간의 Drag &amp; Drop 테스트 <span style="font-size:12px; color: #aaa; font-style: italic;">왼쪽 그리드 행 데이터를 드래그하여 오른쪽 그리드에 이동시켜 결과를 확인할 수 있습니다.</span></div>
    <SBGrid
      id="grid"
      class="grids"
      style="width: 45%; height: 400px; margin-right:20px;"
      ref="grid"
      :data="gridJson"
      :columns="grid1columns"
      :gridattr="{
        showtotalrows:true,
        backcoloralternate: '#efefef',
        rowheight: '26',}"
    ></SBGrid>
    <SBGrid
      id="grid2"
      class="grids"
      style="width: 45%; height: 400px; "
      ref="grid2"
      :data="[]"
      :columns="grid1columns"
      :gridattr="{
        showtotalrows:true,
        backcoloralternate: '#efefef',
        rowheight: '26',}"
    ></SBGrid>
  </div>
</template>

<script>
import SBGrid from '../SBGrid.vue'
export default {
  data: function() {
    return {
      gridJson,
      grid1columns
    }
  },
  components: {
    SBGrid
  },
  mounted: function() {
    this.$nextTick(function() {
      window.vl.$refs.view.$refs.grid.gridObject.setDnD({target : 'grid2', type : 'move', position : 'insert', stylesync : false});
      window.vl.$refs.view.$refs.grid2.gridObject.setDnD({target : 'grid', type : 'move', position : 'insert', stylesync : false});
    })
  },
}

var gridJson = 
[
  {"sub": "한국철도공사","project": "차세대KOVIS(SAPERP)구축","isnew": "계속",},
  {"sub": "국민연금공단","project": "상시모니터링 구축","isnew": "계속",},
  {"sub": "충남 당진시","project": "통합민원시스템구축","isnew": "계속",},
  {"sub": "질병관리본부","project": "의료방사선안전관리플랫폼구축","isnew": "계속",},
  {"sub": "한국농촌경제연구원","project": "통합정보시스템 전면 재 구축","isnew": "계속",},
  {"sub": "한국환경공단","project": "폐자원에너지종합정보관리시스템","isnew": "계속",},
  {"sub": "한국환경공단","project": "폐기물 관리 시스템","isnew": "계속",},
  {"sub": "해양환경관리공단","project": "상시모니터링 구축","isnew": "계속",},
  {"sub": "교육부","project": "교육정보시스템구축","isnew": "계속",},
  {"sub": "행정자치부","project": "정부지식공유활용기반고도화클라우드플랫폼구축","isnew": "계속",},
  {"sub": "행정자치부","project": "국가정보자원 개방 및 공유체계 구축4차 사업","isnew": "계속",},
  {"sub": "행정자치부","project": "국가정보자원 개방 및 공유체계 구축3차 사업","isnew": "계속",},
  {"sub": "방위사업청","project": "국방전자조달서비스고도화사업","isnew": "계속",},
  {"sub": "외교부","project": "북미지역주요인사DB시스템재구축사업","isnew": "계속",},
  {"sub": "한국정보화진흥원","project": "정부지식공유활용기반 고도화","isnew": "계속",},
  {"sub": "교통안전공단","project": "주차장통합정보관리시스템구축용역","isnew": "계속",},
  {"sub": "농림수산식품교육문화정보원","project": "공공데이터 포털","isnew": "계속",},
  {"sub": "축산물품질평가원","project": "공공데이터 포털","isnew": "계속",},
  {"sub": "축산물품질평가원","project": "데이터베이스 주민등록번호 정비 및 품질개선 구축 사업","isnew": "계속",},
  {"sub": "건강보험관리공단","project": "장기요양 모바일 정보시스템 구축","isnew": "계속",},
  {"sub": "국가수리과학연구소","project": "R&D 경영혁신 정보시스템 구축","isnew": "계속",},
  {"sub": "산업안전보건공단","project": "상시감시 모니터링 시스템","isnew": "계속",},
  {"sub": "한국교육과정평가원","project": "연구사업관리시스템(RIMS)","isnew": "계속",},
  {"sub": "한국금융연수원","project": "LMS구축","isnew": "계속",},
  {"sub": "대검찰청","project": "양형정보시스템구축","isnew": "계속",},
  {"sub": "서울시청","project": "법인.시설관리시스템구축","isnew": "계속",},
  {"sub": "서울시청","project": "건설정보관리시스템(ONE PMIS)","isnew": "계속",},
  {"sub": "한국건설기술연구원","project": "통합연구시스템","isnew": "계속",},
  {"sub": "한국발명진흥회","project": "경영정보시스템구축","isnew": "계속",},
  {"sub": "한국언론진흥재단","project": "차세대 ERPㆍ그룹웨어 시스템 구축 사업","isnew": "계속",},
  {"sub": "공정거래위원회","project": "스마트컨슈머 DB서버 이중화 및 기능개선 사업","isnew" : "계속",},
  {"sub": "우정사업본부","project": "FDS구축","isnew" : "계속", },
  {"sub": "의료기관평가인증원","project": "의료기관 인증·평가시스템 전자정부 표준 프레임워크 개선 사업","isnew" : "계속",},
  {"sub": "한국거래소","project": "감사사시스템","isnew" : "계속",  },
  {"sub": "경기개발공사","project": "전세임대기금 연계관리시스템구축용역","isnew" : "계속",},
  {"sub": "국방전산정보원","project": "암호장비관리체계 구축","isnew": "계속",},
  {"sub": "대구시","project": "원클릭 시정관리시스템 구축","isnew": "계속",},
  {"sub": "통계청","project": "2015 기준 경제총조사 시스템","isnew": "계속",},
  {"sub": "통계청","project": "2015 인구주택총조사 시스템 및 농총 통합관리 시스템","isnew": "계속","status": "승인요청"},
  {"sub": "한국기초과학지원연구원","project": "KBSI통합경영정보시스템구축","isnew": "계속","status": "승인요청"},
  {"sub": "경제인문사회연구회","project": "출연연재정정보시스템1차구축사업(34개기관확산예정)","isnew": "계속",},
  {"sub": "국방과학연구원","project": "통합연구개발체계시스템","isnew": "계속",},
  {"sub": "농림축산식품부","project": "공공데이터포털고도화","isnew": "계속",},
  {"sub": "식품 의약품 안전처","project": "식품이력추적시스템","isnew": "계속",},
  {"sub": "정보통신정책연구원","project": "STAT 시스템 기능 개선","isnew": "계속",},
  {"sub": "한국농수산물유통공사","project": "정가 수의매매 예약거래 정보제공 시스템","isnew": "계속",},
  {"sub": "보훈공단","project": "e감사시스템구축","isnew": "계속",},
  {"sub": "한국산업단지공단","project": "e감사시스템구축","isnew": "계속",},
  {"sub": "한국산업단지공단","project": "상시모니터링구축","isnew": "계속",}
];
var grid1columns = [
    {caption : ['세부사업명'],   ref : 'project',    width : '40%',  style : 'text-align:left',    type : 'input'},
    {caption : ['보조구분'],    ref : 'sub',        width : '30%',  style : 'text-align:center',    type : 'input'},
    {caption : ['사업구분'],    ref : 'isnew',      width : '30%',  style : 'text-align:center',    type : 'input'},
];
</script>

<style>
</style>